import React, { useState, useEffect } from "react";
import { Link, useHistory, useOutletContext, useParams } from "react-router-dom";
import { BrowserRouter as Router } from "react-router-dom";
// import db from "../../../api/mongodb";
import { Container, Row, Col, Image, Card, Button } from "react-bootstrap";
// import { defaultOptions1 } from "../../../config/loading-config.js";
// import Lottie from "react-lottie";
import "./SafeAPProfile.scss";
import DummyProfilePic from "../../../../images/dummy-profile-picture.svg";



const SafeAPProfileListSection = ({ listItems, isProject }) => {

    const {
        projects,
        setProjects,
        filteredProjects,
        setFilteredProjects,
        safeAp,
        safeApId,
        // isLoading,
        setSafeAp,
        // setIsLoading,
    } = useOutletContext();

    if (listItems.length === 0) {
        return (
            <div>
                <Card className="safe-ap-profile-list-item" style={{ width: "100%" }}>
                    <Card.Body>
                        No {isProject ? <>projects</> : <>courses</>} yet
                    </Card.Body>
                </Card>
            </div>
        );
    }

    const renderedList = listItems.map((listItem) => {
        // console.log(listItem)
        const item = (
            <Link
                key={listItem._id}
                to={{
                    pathname: `/projects/profile/${listItem._id}`,
                    state: { safeApId: safeApId },
                }}
                style={{textDecoration:"none"}}
            >
                <Card
                    className="safe-ap-profile-list-item"
                    style={{ width: "100%" }}
                >
                    <Card.Body style={{width:"100%"}}>
                        <div className="safe-ap-profile-list-item-content">
                            <div className="safe-ap-profile-list-item-img">
                                {/* {listItem.img.length && <img src={listItem.img[0].content} />} */}
                                <img
                                    src={
                                        listItem.formData.img && listItem.formData.img.length
                                            ? listItem.formData.img[0].content
                                            : DummyProfilePic
                                    }
                                    alt=""
                                    
                                ></img>
                            </div>
                            <div className="safe-ap-list-item-description" >
                                <h5>{listItem.formData.projectName}</h5>
                                {isProject ? (
                                    <p>
                                        {listItem.formData.projectCity}, {listItem.formData.projectCountry}
                                    </p>
                                ) : null}
                            </div>
                        </div>
                    </Card.Body>
                </Card>
            </Link>

        );

        return item;
    });

    return <>{renderedList}</>;
};

export default SafeAPProfileListSection;
